import ProjectItem from "../components/ProjectItem";
import GASidebar from "../components/GASidebar";
import projectsData from "../data/projectsData";

function Gallery() {
  const galleryItems = projectsData.filter((p) =>
      ['glenmarie-00', 'seresta-01', 'the-park-02', 'ttdi-01', 'danson-00', 'maluri-02', 'aracafe-01', 'the-pulse-04', 'foxboro-02'].includes(p.id)
    );

      return (
        <section className="gallery">
          <div className="projects-container">
            <GASidebar />
            {/*}
            <div className="projects-sidebar">
              <h2>Gallery</h2>
              <ul>
                <li><a href="#condominium">Condominium</a></li>
                <li><a href="#semi-d">Semi-D</a></li>
                <li><a href="#commercial">Commercial</a></li>
                <li><a href="#landed">Landed</a></li>
              </ul>
            </div>
            */}
            <div className="projects-main">
              <div className="gallery-grid">
                {galleryItems.map((item) => (
                  <ProjectItem
                    key={item.id}
                    id={item.id}
                    image={item.titleImage}
                    title={item.title}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      );
  }
  
  export default Gallery;